import {
  Box,
  Dialog,
  DialogContent,
  DialogTitle,
  IconButton,
  Paper,
  Typography,
} from "@mui/material";
import { Close as CloseIcon } from "@mui/icons-material";
import React from "react";

interface GoalScorer {
  _id: string;
  playerId: string;
  playerCardId: string;
  name: string;
  time: number;
}

interface GoalScorersModalProps {
  open: boolean;
  onClose: () => void;
  myTeamGoalScorers: GoalScorer[];
  oppTeamGoalScorers: GoalScorer[];
}

const GoalScorersModal: React.FC<GoalScorersModalProps> = ({
  open,
  onClose,
  myTeamGoalScorers,
  oppTeamGoalScorers,
}) => {
  return (
    <Dialog open={open} onClose={onClose} maxWidth="md" fullWidth>
      <DialogTitle>
        <Box
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h6" fontWeight={"bold"}>
            Goal Scorers
          </Typography>
          <IconButton onClick={onClose} size="small">
            <CloseIcon />
          </IconButton>
        </Box>
      </DialogTitle>
      <DialogContent>
        <Box
          style={{
            display: "flex",
            gap: 20,
            flexDirection: "column",
            paddingTop: 8,
          }}
        >
          {/* My Team Goal Scorers */}
          {myTeamGoalScorers && myTeamGoalScorers.length > 0 && (
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography
                variant="h6"
                fontWeight={"bold"}
                color="primary"
                gutterBottom
              >
                My Team Goals ({myTeamGoalScorers.length})
              </Typography>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  marginTop: 16,
                }}
              >
                {myTeamGoalScorers
                  .sort((a, b) => a.time - b.time)
                  .map((scorer, index) => (
                    <Box
                      key={`modal-my-${index}`}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px 16px",
                        backgroundColor: "#e3f2fd",
                        borderRadius: "8px",
                        borderLeft: "4px solid #1976d2",
                      }}
                    >
                      <Box>
                        <Typography variant="body1" fontWeight={"bold"}>
                          {scorer.name}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          display="block"
                        >
                          Player ID: {scorer.playerId}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          display="block"
                        >
                          Player Card ID: {scorer.playerCardId}
                        </Typography>
                      </Box>
                      <Box style={{ textAlign: "right" }}>
                        <Typography
                          variant="h6"
                          fontWeight={"bold"}
                          color="primary"
                        >
                          {scorer.time}'
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Goal {index + 1}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
              </Box>
            </Paper>
          )}

          {/* Opponent Team Goal Scorers */}
          {oppTeamGoalScorers && oppTeamGoalScorers.length > 0 && (
            <Paper elevation={2} sx={{ p: 3 }}>
              <Typography
                variant="h6"
                fontWeight={"bold"}
                color="error"
                gutterBottom
              >
                Opponent Team Goals ({oppTeamGoalScorers.length})
              </Typography>
              <Box
                style={{
                  display: "flex",
                  flexDirection: "column",
                  gap: 10,
                  marginTop: 16,
                }}
              >
                {oppTeamGoalScorers
                  .sort((a, b) => a.time - b.time)
                  .map((scorer, index) => (
                    <Box
                      key={`modal-opp-${index}`}
                      style={{
                        display: "flex",
                        justifyContent: "space-between",
                        alignItems: "center",
                        padding: "12px 16px",
                        backgroundColor: "#ffebee",
                        borderRadius: "8px",
                        borderLeft: "4px solid #d32f2f",
                      }}
                    >
                      <Box>
                        <Typography variant="body1" fontWeight={"bold"}>
                          {scorer.name}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          display="block"
                        >
                          Player ID: {scorer.playerId}
                        </Typography>
                        <Typography
                          variant="caption"
                          color="text.secondary"
                          display="block"
                        >
                          Player Card ID: {scorer.playerCardId}
                        </Typography>
                      </Box>
                      <Box style={{ textAlign: "right" }}>
                        <Typography
                          variant="h6"
                          fontWeight={"bold"}
                          color="error"
                        >
                          {scorer.time}'
                        </Typography>
                        <Typography variant="caption" color="text.secondary">
                          Goal {index + 1}
                        </Typography>
                      </Box>
                    </Box>
                  ))}
              </Box>
            </Paper>
          )}

          {/* No Goals Message */}
          {(!myTeamGoalScorers || myTeamGoalScorers.length === 0) &&
            (!oppTeamGoalScorers || oppTeamGoalScorers.length === 0) && (
              <Box style={{ textAlign: "center", padding: 40 }}>
                <Typography variant="body1" color="text.secondary">
                  No goals scored in this match
                </Typography>
              </Box>
            )}
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default GoalScorersModal;
